const productItems = document.querySelectorAll('.product-grid .grid__item');

productItems.forEach(productItem => {
    const variants = productItem.querySelectorAll('.card__information-variants input[type="radio"]');
    if (variants.length <= 1) {
        return;
    }

    const emblaApi = productItem.querySelector('.embla').emblaApi;
    const productLink = productItem.querySelector('.card__information a');
    const slideNodes = emblaApi.slideNodes()

    variants.forEach(variant => {
        slideNodes.forEach(slideNode => {
            if (slideNode.dataset.carouselControlId === variant.id) {
                variant.addEventListener('change', () => {
                    productLink.href = slideNode.href;
                });
            }
        });
    });
});